export function setAppError(state, message) {
  return {
    ...state,
    app: {
      ...state.app,
      status: "error",
      message: message
    }
  };
}

export function setAppStatus(state, status) {
  return {
    ...state,
    app: {
      ...state.app,
      status: status
    }
  };
}